/**
 * Feature flags — opt-in / default-off convention.
 *
 * A flag reads a `VITE_*` env var at call time and returns `false` unless the
 * value is explicitly `'true'` or `'1'` (case-insensitive, trimmed). Unset,
 * empty, or unrecognized values are always disabled. This keeps new features
 * hidden by default across deployments until an environment explicitly opts in.
 *
 * Flags in this file are boolean opt-ins, default-off.
 */

function parseBooleanFlag(raw: string | undefined): boolean {
  const normalized = (raw ?? '').trim().toLowerCase();
  return normalized === 'true' || normalized === '1';
}

export function isAddMemberEnabled(): boolean {
  return parseBooleanFlag(import.meta.env.VITE_SHOW_ADD_MEMBER);
}

export function isMemberPenaltiesEnabled(): boolean {
  return parseBooleanFlag(import.meta.env.VITE_SHOW_MEMBER_PENALTIES);
}
